import { createReducer } from '@topconagriculture/frontend-utils';

import { DriverPermission } from './driverPermissions.types';
import { getDriverPermissions, updateDriverPermissions } from './driverPermissions.actions';

export type DriverPermissionsState = DriverPermission[];

const initialState: DriverPermissionsState = [];

const driverPermissionsReducer = createReducer(initialState, {
  [getDriverPermissions.done.type]: (
    state: DriverPermissionsState,
    action: ReturnType<typeof getDriverPermissions.done>,
  ) => action.payload.result,
  [updateDriverPermissions.done.type]: (
    state: DriverPermissionsState,
    action: ReturnType<typeof updateDriverPermissions.done>,
  ) =>
    state.map((permission) => {
      const newPermission = action.payload.result.find((res) => res.permissionType === permission.permissionType);
      return newPermission ? { ...permission, ...newPermission } : permission;
    }),
});

export default driverPermissionsReducer;
